import styled from '@emotion/styled';

export const JsonViewer = styled.pre`
    text-align: left;
    text-wrap: wrap;
    word-wrap: break-word;
`;

export const MenuWrapper = styled.div<{ disabled?: boolean }>`
    height: 100%;
    ${({ disabled }) =>
        disabled &&
        `
        pointer-events: none;
        opacity: 0.5;
    `}
`;
